import { theme } from '@noths/polaris-client-ribbons-base';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { spacing } = theme;

export const row = css`
  display: flex;
  align-items: center;
  column-gap: ${spacing.md}px;
  margin-bottom: ${spacing.md}px;
  border-bottom: 1px solid var(${themeVariables.colors.stroke.interactive});

  & > * {
    margin-bottom: 0;
  }
`;
